import store from 'store'
import sessionStorage from 'store/storages/sessionStorage'
import json2Plugin from 'store/plugins/json2'

// 创建专门使用sessionStorage的store实例
const sessionStorageStore = store.createStore([sessionStorage], [json2Plugin])

export default sessionStorageStore